<div class="roadmap-wrapper">
  <div class="roadmap">
    <div
      class="roadmap-item"
      *ngFor="let step of steps; let i = index"
      [ngClass]="{ 'odd': i % 2 === 0, 'even': i % 2 !== 0 }"
    >
      <div class="circle">{{ i + 1 }}</div>
      <div class="content">
        <h4>Step {{ i + 1 }}</h4>
        <p>{{ step.text }}</p>
      </div>
    </div>
    <div class="roadmap-path"></div>
  </div>
</div>
